import type { LoginAccountList, LoginAccountsSource } from '@felix/ui';
import { api, officeApi } from './api.js';
import { officeSetupSource } from './setup-source.js';

/**
 * Crew ▸ Login Accounts (ADR 0147): tek okuma ucu; yazmalar Settings ▸ Users'ın ve personel
 * kartının var olan uçlarıdır (ADR 0145, ADR 0131 Ek 1). Uçlar değişmez.
 */
export const officeLoginAccountsSource: LoginAccountsSource = {
  list: (withoutLogin) =>
    api<LoginAccountList>(`/office/login-accounts${withoutLogin ? '?withoutLogin=1' : ''}`),
  resetPassword: (userId, rowVersion, password) =>
    officeSetupSource.resetPassword(userId, rowVersion, password),
  changeEmail: (userId, rowVersion, email, password) =>
    officeSetupSource.changeEmail(userId, rowVersion, email, password),
  setActive: (userId, rowVersion, active, password) =>
    active
      ? officeSetupSource.enableUser(userId, rowVersion, password)
      : officeSetupSource.disableUser(userId, rowVersion, password),
  resetTotp: (userId, password) => officeSetupSource.resetTotp(userId, password),
  createLogin: (userId, email, password) => officeApi.createCrewLogin(userId, email, password),
};
